import { Asset } from "@hydrologiq/gql-experience/graphql"
import { Link } from "../components/Link"
import { useRoute } from "../providers/helpers/useRoute"

interface AssetLinkProps {
    asset: Asset
    openExternal?: boolean
    size?: "xs" | "sm" | "md" | "lg" | string
    iconSize?: number
    tooltip?: boolean
    truncate?: boolean
    maxWidth?: string
    /** Render without the open-in-new-tab icon */
    internal?: boolean
}

export const AssetLink = ({ asset, openExternal = false, size, iconSize, tooltip = true, truncate = false, maxWidth, internal = false }: AssetLinkProps) => {
    const route = useRoute()
    const isMonitoring = asset.monitoring_status === "active"
    let basePath = `${route.endsWith("/") ? route : route + "/"}${asset.id}`
    let href = openExternal ? `/assets/${asset.id}` : basePath

    if (isMonitoring) href += "/monitoring"

    return <Link href={href} fontSize={size} iconSize={iconSize} truncate={truncate} maxWidth={maxWidth} tooltip={tooltip} internal={internal}>{asset.name}</Link>

}

export default AssetLink